<template>
  <div id="payment-setting">
    <iframe
      frameborder="1"
      :height="`${height}px`"
      width="100%"
      scrolling="no"
      :src="`${VUE_APP_BASE_AUTH_MODULE}/setting/payment`"
      allow="clipboard-read; clipboard-write"
    />

  </div>
</template>
<script>
export default {
  components: {
  },
  data() {
    return {
      height: 0,
      VUE_APP_BASE_AUTH_MODULE: process.env.VUE_APP_BASE_AUTH_MODULE,
      dataOrder: {},
      url: '',
      dataQris: {},
    }
  },
  mounted() {
    window.addEventListener('message', event => {
      if (event.origin === this.VUE_APP_BASE_AUTH_MODULE) {
        const {
          type, data, order, link, route,
        } = event.data
        if (type === 'SET_DIMENSION') {
          this.height = Math.floor(data.height) + 150
        }
        if (type === 'ACCEPT_ORDER') {
          this.$bvModal.show('modal-acc-order')
          this.dataOrder = order
        }
        if (type === 'CHECK_PROOF_TRANSFER') {
          this.$bvModal.show('check-proof-transfer')
          this.url = link
        }
        if (type === 'HANDLE_TOP_UP') {
          this.$bvModal.show('modal-top-up-komchat-coin')
        }
        if (type === 'route') {
          this.$router.push(route)
        }
      }
    })
  },
  methods: {

  },
}
</script>
